import React from 'react'
import SpeciesDetailsSearchForm from './SpeciesDetailsSearchForm'


const SpeciesDetails = ({site}) => {
  return (
    <>
      <SpeciesDetailsSearchForm site={site}/>
    </>
  )
}

export default SpeciesDetails
